import React from 'react';
import type { ZoneId } from '../../types/ambilight';
import { LightNode } from './LightNode';
import { useAmbilightContext } from '../../context/AmbilightContext';

export const LightNodesOverlay: React.FC = () => {
  const { points } = useAmbilightContext();

  const getPoint = (id: ZoneId) => points.find((p) => p.id === id);

  const renderNode = (id: ZoneId, positionClass: string) => {
    const point = getPoint(id);
    if (!point) return null;
    return (
      <div className={`absolute ${positionClass} z-30`}>
        <LightNode point={point} />
      </div>
    );
  };

  return (
    <div className="absolute inset-0 pointer-events-none z-30">
      <div className="relative w-full h-full pointer-events-auto">
        {/* 4 ESQUINAS DEL MONITOR (Literal en las 4 esquinas exactas) */}
        {renderNode('top-left', 'top-0 left-0 -translate-x-1/2 -translate-y-1/2')}
        {renderNode('top-right', 'top-0 left-full -translate-x-1/2 -translate-y-1/2')}
        {renderNode('bottom-left', 'top-full left-0 -translate-x-1/2 -translate-y-1/2')}
        {renderNode('bottom-right', 'top-full left-full -translate-x-1/2 -translate-y-1/2')}

        {/* 4 BORDES CENTRALES */}
        {renderNode('top', 'top-0 left-1/2 -translate-x-1/2 -translate-y-1/2')}
        {renderNode('right', 'top-1/2 left-full -translate-x-1/2 -translate-y-1/2')}
        {renderNode('bottom', 'top-full left-1/2 -translate-x-1/2 -translate-y-1/2')}
        {renderNode('left', 'top-1/2 left-0 -translate-x-1/2 -translate-y-1/2')}

        {/* NODO CENTRAL: TODA LA PANTALLA */}
        {renderNode('all', 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2')}
      </div>
    </div>
  );
};
